export const sendContactForm = async (data: any, template: string) => {
  const API_URL = `/api/contact`;

  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ...data, template }),
    };
    const value = await fetch(API_URL, config);

    return value;
  } catch (error) {
    return error;
  }
};
